<div id="login-wrapper">

  <div class="logo">
    <img src="assets/layout/images/White_koncentro-registrato.svg" alt="" />
  </div>

  <div id="login-container">

    <div class="title">
      The Retail Digital Business Platform
    </div>

    <!-- dati per la login -->
    <div *ngIf="step == 1" class="ui-g ui-fluid">
      <form #f="ngForm" (ngSubmit)="onLoginSubmit($event, userField, passwordField, rememberMeField)" >
        <div class="ui-g-12">
          <input
                 #userField
                 id="username"
                 data-testid="username"
                 name="userField"
                 type="text"
                 autocomplete="off"
                 class="ui-inputtext ui-corner-all ui-state-default ui-widget"
                 placeholder="{{ 'login.userPlaceHolder' | translate }}"
                 required
          />
        </div>
        <div class="ui-g-12">
          <input
            #passwordField
            id="password"
            data-testid="password"
            name="passwordField"
            type="password"
            autocomplete="off"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget"
            placeholder="{{ 'login.passwordPlaceHolder' | translate }}"
            required
          />
        </div>
        <div class="ui-g-12 ui-md-6">
          <label class="remember-me"><input
            #rememberMeField
            id="rememberMe"
            name="rememberMeField"
            type="checkbox"
          />
          &nbsp;{{ 'login.rememberMe' | translate }}</label>

        </div>
        <div class="ui-g-12 ui-md-6 text-right">
          <a id="forgotPassword" (click)="onPasswordForget($event)" href="javascript:void(0)">{{ 'login.forgotPassword' | translate }}</a>
        </div>
        <div class="ui-g-12">
          <button data-testid="submitLogin" type="submit" id="submit" pButton label="{{ 'login.loginButton' | translate }}"></button>
        </div>
        <div class="ui-g-12 text-right" style="font-size: small">
          v {{ version }}
        </div>
      </form>
    </div>
    <!-- user company selection -->
    <div *ngIf="step == 2" class="ui-g ui-fluid">
      <form #f="ngForm" (ngSubmit)="onCompanySubmit($event)" >
        <div class="ui-g-12">
          <span>{{ 'login.selectCompany' | translate }}</span>
        </div>
        <div class="ui-g-12">
          <p-dropdown [style]="{'width':'100%'}" data-testid="companyDropDown" id="dropdownCompany" name="companyDropDown" [options]="companies" [(ngModel)]="selectedCompany"></p-dropdown>
        </div>
        <div class="ui-g-12">
          <button data-testid="submitCompany" id="select" type="submit" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-icon-left">
            <span class="ui-button-icon-left ui-c fa fa-fw ui-icon-person"></span>
            <span class="ui-button-text ui-c">{{ 'login.select' | translate }}</span>
          </button>
        </div>
      </form>
    </div>
    <!-- change password -->
    <div *ngIf="step == 3" class="ui-g ui-fluid">
      <form #f="ngForm" (ngSubmit)="onChangePasswordSubmit($event, newPasswordField, confirmNewPasswordField)">
        <div class="ui-g-12">
          <span>{{ 'login.changePassword' | translate }}</span>
        </div>
        <div class="ui-g-12">
          <span>{{ 'login.passwordSafeRules' | translate }}</span>
        </div>
        <div class="ui-g-12">
          <input
            #newPasswordField
            id="newPassword"
            name="newPasswordField"
            type="password"
            autocomplete="off"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget"
            placeholder="{{ 'login.newPasswordPlaceHolder' | translate }}"
            required
            minlength="8"
            pattern="(?=^.{8,100}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*"
          />
        </div>
        <div class="ui-g-12">
          <input
            #confirmNewPasswordField
            id="confirmNewPassword"
            name="confirmNewPasswordField"
            type="password"
            autocomplete="off"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget"
            placeholder="{{ 'login.newPasswordConfirmationPlaceHolder' | translate }}"
            required
            minlength="8"
            pattern="(?=^.{8,100}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*"
          />
        </div>
        <div class="ui-g-12">
          <button data-testid="changePassword" type="submit" pButton label="{{ 'login.changePasswordButton' | translate }}"></button>
        </div>
      </form>
    </div>
  </div>

  <div class="login-footer">Konvergence © All Rights Reserved</div>

</div>

<p-dialog header="{{'userForm.forgotPasswordTitle' | translate}}" [(visible)]="displayForgot" id="popUpForgotPassword" modal="popUp" width="500" [responsive]="true">
  <p>{{'userForm.forgotPasswordMessage' | translate}}</p>
  <p-footer>
    <button style="margin-bottom: 20px; margin-right: 20px; float: right;" id="closeDialog" type="button" pButton icon="fa fa-close" (click)="displayForgot=false" label="{{'common.close' | translate}}"></button>
  </p-footer>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/login/login.html